"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Link_1 = __importDefault(require("@mui/material/Link"));
var Collapse_1 = __importDefault(require("@mui/material/Collapse"));
var Lang_js_1 = require("../Lang.js");
var mountIsland_1 = require("../mountIsland");
// Site-specific dark navy not represented in the MUI palette
var NAVY = '#1c1c3c';
var MOCK_DATA = {
    member_id: 123,
    statuses: {
        initiate: { active: true },
        minister: { active: false },
        discourse: true,
        sat: false,
    },
    discourses: {
        subscribed: true,
        lapsed: false,
        current_year: 7,
        expires: 'May 2026',
        renew_after: 'February 2026',
        renewal_eligible: false,
        status: 'Active',
        completed: false,
    },
    sats: {
        subscribed: false,
        lapsed: false,
        primary: false,
        expires: null,
        renew_after: null,
        renewal_eligible: false,
        status: 'Not Subscribed',
        discourse_completed: false,
    },
    twi: {
        subscribed: true,
        lapsed: false,
        plan: 'TWI Premium',
        next_payment: '2025-12-28',
        expired_on: '',
        manage_url: '/app/twi/subscriptions',
    },
    product_info: {
        discourse: { title: '', description: '', purchase_note: '' },
        sat: { title: '', description: '', purchase_note: '' },
    },
};
function formatDate(dateStr, format) {
    if (format === void 0) { format = 'full'; }
    if (!dateStr || dateStr === '0000-00-00')
        return '';
    var _a = dateStr.split('-').map(Number), y = _a[0], m = _a[1], d = _a[2];
    var date = new Date(y, m - 1, d);
    if (format === 'monthYear') {
        return date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
    }
    return date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
}
function isRenewalEligible(renewalDate) {
    if (!renewalDate || renewalDate === '0000-00-00')
        return false;
    var _a = renewalDate.split('-').map(Number), y = _a[0], m = _a[1], d = _a[2];
    var renewal = new Date(y, m - 1, d);
    var now = new Date();
    var diffMs = renewal.getTime() - now.getTime();
    var diffDays = diffMs / (1000 * 60 * 60 * 24);
    return diffDays <= 183;
}
function getRenewAfterDate(renewalDate) {
    if (!renewalDate || renewalDate === '0000-00-00')
        return '';
    var _a = renewalDate.split('-').map(Number), y = _a[0], m = _a[1], d = _a[2];
    var date = new Date(y, m - 1, d);
    date.setDate(date.getDate() - 183);
    return date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
}
/**
 * Collapsible details for a subscription row. Renders nothing when the
 * backend didn't return any product info (empty description AND empty note) —
 * so a missing Spanish slug or unmapped product just hides the block rather
 * than showing an empty accordion.
 *
 * Description + purchase_note come from the MSIA Store (WooCommerce product
 * `post_content` and `_purchase_note` postmeta). They are HTML-authored by
 * admins in WP, so we render via dangerouslySetInnerHTML.
 */
var ProductDetails = function (_a) {
    var info = _a.info;
    var _b = (0, react_1.useState)(false), open = _b[0], setOpen = _b[1];
    if (!info.description && !info.purchase_note)
        return null;
    return (react_1.default.createElement(Box_1.default, { sx: {
            mt: '4px',
            backgroundColor: '#fff',
            borderRadius: 2,
            boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
            overflow: 'hidden',
        } },
        react_1.default.createElement(Box_1.default, { onClick: function () { return setOpen(!open); }, sx: {
                cursor: 'pointer',
                p: '10px 18px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                fontSize: '13px',
                fontWeight: 600,
                color: NAVY,
                '&:hover': { backgroundColor: 'rgba(0,0,0,0.02)' },
            } },
            react_1.default.createElement("span", null, open ? (0, Lang_js_1.__)('Hide details') : (0, Lang_js_1.__)('View details')),
            react_1.default.createElement("span", { style: { fontSize: '12px' } }, open ? '▲' : '▼')),
        react_1.default.createElement(Collapse_1.default, { in: open },
            react_1.default.createElement(Box_1.default, { sx: { p: '0 20px 18px 20px', fontSize: '14px', lineHeight: 1.6, color: '#333' } },
                info.description && (react_1.default.createElement(Box_1.default, { sx: { '& p:first-of-type': { mt: 0 }, '& p:last-of-type': { mb: 0 } }, dangerouslySetInnerHTML: { __html: info.description } })),
                info.purchase_note && (react_1.default.createElement(Box_1.default, { sx: {
                        mt: info.description ? '12px' : 0,
                        pt: info.description ? '12px' : 0,
                        borderTop: info.description ? '1px solid #eee' : 'none',
                        fontSize: '13px',
                        color: '#555',
                    } },
                    react_1.default.createElement(Box_1.default, { sx: { '& p:first-of-type': { mt: 0 }, '& p:last-of-type': { mb: 0 } }, dangerouslySetInnerHTML: { __html: info.purchase_note } })))))));
};
var SubscriptionPortal = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
    var container = document.getElementById('student-subscriptions-portal');
    var dataset = (container === null || container === void 0 ? void 0 : container.dataset) || {};
    // Read real role data from Blade data attributes, fall back to mock
    var memberId = dataset.memberId || MOCK_DATA.member_id;
    var isInitiate = dataset.isInitiate === '1';
    var isMinister = dataset.isMinister === '1';
    var isDiscourse = dataset.isDiscourse === '1';
    var isSat = dataset.isSat === '1';
    var subscriptionsRaw = dataset.subscriptions;
    var subscriptions = null;
    try {
        subscriptions = subscriptionsRaw ? JSON.parse(subscriptionsRaw) : null;
    }
    catch (e) {
        console.warn('Failed to parse subscription data', e);
    }
    var data = subscriptions ? {
        member_id: memberId,
        statuses: {
            initiate: { active: isInitiate },
            minister: { active: isMinister },
            discourse: isDiscourse,
            sat: isSat,
        },
        discourses: {
            subscribed: isDiscourse && !!subscriptions.discourse,
            lapsed: !isDiscourse && !!subscriptions.discourse,
            current_year: ((_a = subscriptions.discourse) === null || _a === void 0 ? void 0 : _a.curryear) || 0,
            expires: subscriptions.discourse ? formatDate(subscriptions.discourse.renewal_needed_by, 'monthYear') : null,
            renew_after: subscriptions.discourse ? getRenewAfterDate(subscriptions.discourse.renewal_needed_by) : null,
            renewal_eligible: subscriptions.discourse ? isRenewalEligible(subscriptions.discourse.renewal_needed_by) : false,
            status: ((_b = subscriptions.discourse) === null || _b === void 0 ? void 0 : _b.substatus) || 'Not Subscribed',
            completed: (((_c = subscriptions.discourse) === null || _c === void 0 ? void 0 : _c.curryear) || 0) >= 12,
        },
        sats: {
            subscribed: isSat && ((_d = subscriptions.sats) === null || _d === void 0 ? void 0 : _d.length) > 0,
            lapsed: !isSat && ((_e = subscriptions.sats) === null || _e === void 0 ? void 0 : _e.length) > 0,
            primary: ((_g = (_f = subscriptions.sats) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.primstat) === 'Primary',
            expires: ((_h = subscriptions.sats) === null || _h === void 0 ? void 0 : _h[0]) ? formatDate(subscriptions.sats[0].renewal_needed_by, 'monthYear') : null,
            renew_after: ((_j = subscriptions.sats) === null || _j === void 0 ? void 0 : _j[0]) ? getRenewAfterDate(subscriptions.sats[0].renewal_needed_by) : null,
            renewal_eligible: ((_k = subscriptions.sats) === null || _k === void 0 ? void 0 : _k[0]) ? isRenewalEligible(subscriptions.sats[0].renewal_needed_by) : false,
            status: ((_m = (_l = subscriptions.sats) === null || _l === void 0 ? void 0 : _l[0]) === null || _m === void 0 ? void 0 : _m.substatus) || 'Not Subscribed',
            discourse_completed: false,
        },
        twi: {
            subscribed: ((_o = subscriptions.twi) === null || _o === void 0 ? void 0 : _o.status) === 'active',
            lapsed: !!subscriptions.twi && ((_p = subscriptions.twi) === null || _p === void 0 ? void 0 : _p.status) !== 'active',
            plan: ((_q = subscriptions.twi) === null || _q === void 0 ? void 0 : _q.plan_name) || '',
            next_payment: subscriptions.twi
                ? formatDate((_r = subscriptions.twi.next_billing_date) !== null && _r !== void 0 ? _r : subscriptions.twi.expiration_date)
                : '',
            expired_on: subscriptions.twi
                ? formatDate((_s = subscriptions.twi.next_billing_date) !== null && _s !== void 0 ? _s : subscriptions.twi.expiration_date)
                : '',
            manage_url: '/app/twi/subscriptions',
        },
        product_info: subscriptions.product_info || {
            discourse: { title: '', description: '', purchase_note: '' },
            sat: { title: '', description: '', purchase_note: '' },
        },
    } : __assign(__assign({}, MOCK_DATA), { member_id: memberId, statuses: {
            initiate: { active: isInitiate },
            minister: { active: isMinister },
            discourse: isDiscourse,
            sat: isSat,
        } });
    // Shared sx for subscription action links
    var actionLinkSx = function (disabled) { return ({
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: disabled ? 'grey.300' : NAVY,
        color: disabled ? 'text.disabled' : '#fff',
        border: 'none',
        borderRadius: 1.5,
        px: 3.5,
        height: '42px',
        fontSize: '14px',
        fontWeight: 700,
        cursor: disabled ? 'not-allowed' : 'pointer',
        whiteSpace: 'nowrap',
        transition: 'background-color 0.2s ease',
        letterSpacing: '0.5px',
        minWidth: '160px',
        textDecoration: 'none',
        '&:hover': {
            backgroundColor: disabled ? 'grey.300' : '#2a2a4c',
            textDecoration: 'none',
            color: disabled ? 'text.disabled' : '#fff',
        },
    }); };
    // Shared sx for subscription row cards
    var rowCardSx = {
        backgroundColor: '#fff',
        borderRadius: 2,
        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
        p: '20px 24px',
        display: 'flex',
        gap: 3,
        transition: 'box-shadow 0.2s ease',
        '&:hover': {
            boxShadow: '0 3px 10px rgba(0,0,0,0.1)',
        },
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { xs: 'flex-start', sm: 'center' },
        '& > a': {
            width: { xs: '100%', sm: 'auto' },
        },
    };
    return (react_1.default.createElement(Box_1.default, { sx: {
            p: 2,
            maxWidth: '1200px',
            mx: 'auto',
            backgroundColor: '#f5f6f8',
        } },
        react_1.default.createElement(Box_1.default, { sx: {
                backgroundColor: '#fff',
                p: '10px 16px',
                borderRadius: 1.5,
                boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                mb: 2,
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: '10px',
            } },
            react_1.default.createElement(Box_1.default, { sx: {
                    display: 'inline-flex',
                    alignItems: 'center',
                    backgroundColor: NAVY,
                    color: '#fff',
                    px: '14px',
                    py: '6px',
                    borderRadius: '20px',
                    fontSize: '13px',
                    fontWeight: 600,
                    letterSpacing: '0.3px',
                } },
                (0, Lang_js_1.__)('MEMBER ID'),
                ": ",
                data.member_id),
            react_1.default.createElement(Box_1.default, { sx: { display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' } },
                react_1.default.createElement(Box_1.default, { sx: {
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '6px',
                        backgroundColor: data.statuses.initiate.active
                            ? 'rgba(25, 148, 32, 0.08)'
                            : 'rgba(211, 47, 47, 0.08)',
                        px: '12px',
                        py: '6px',
                        borderRadius: '20px',
                    } },
                    react_1.default.createElement(Box_1.default, { component: "span", sx: {
                            width: '8px',
                            height: '8px',
                            borderRadius: '50%',
                            backgroundColor: data.statuses.initiate.active ? 'success.main' : 'error.main',
                            display: 'inline-block',
                        } }),
                    react_1.default.createElement(Typography_1.default, { component: "span", sx: { fontSize: '13px', fontWeight: 500, color: '#333' } }, (0, Lang_js_1.__)('Initiate'))),
                react_1.default.createElement(Box_1.default, { sx: {
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '6px',
                        backgroundColor: data.statuses.minister.active
                            ? 'rgba(25, 148, 32, 0.08)'
                            : 'rgba(211, 47, 47, 0.08)',
                        px: '12px',
                        py: '6px',
                        borderRadius: '20px',
                    } },
                    react_1.default.createElement(Box_1.default, { component: "span", sx: {
                            width: '8px',
                            height: '8px',
                            borderRadius: '50%',
                            backgroundColor: data.statuses.minister.active ? 'success.main' : 'error.main',
                            display: 'inline-block',
                        } }),
                    react_1.default.createElement(Typography_1.default, { component: "span", sx: { fontSize: '13px', fontWeight: 500, color: '#333' } }, (0, Lang_js_1.__)('Minister'))),
                react_1.default.createElement(Box_1.default, { sx: {
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '6px',
                        backgroundColor: data.statuses.discourse
                            ? 'rgba(25, 148, 32, 0.08)'
                            : 'rgba(211, 47, 47, 0.08)',
                        px: '12px',
                        py: '6px',
                        borderRadius: '20px',
                    } },
                    react_1.default.createElement(Box_1.default, { component: "span", sx: {
                            width: '8px',
                            height: '8px',
                            borderRadius: '50%',
                            backgroundColor: data.statuses.discourse ? 'success.main' : 'error.main',
                            display: 'inline-block',
                        } }),
                    react_1.default.createElement(Typography_1.default, { component: "span", sx: { fontSize: '13px', fontWeight: 500, color: '#333' } }, (0, Lang_js_1.__)('Discourse Subscriber'))),
                react_1.default.createElement(Box_1.default, { sx: {
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '6px',
                        backgroundColor: data.statuses.sat
                            ? 'rgba(25, 148, 32, 0.08)'
                            : 'rgba(211, 47, 47, 0.08)',
                        px: '12px',
                        py: '6px',
                        borderRadius: '20px',
                    } },
                    react_1.default.createElement(Box_1.default, { component: "span", sx: {
                            width: '8px',
                            height: '8px',
                            borderRadius: '50%',
                            backgroundColor: data.statuses.sat ? 'success.main' : 'error.main',
                            display: 'inline-block',
                        } }),
                    react_1.default.createElement(Typography_1.default, { component: "span", sx: { fontSize: '13px', fontWeight: 500, color: '#333' } }, (0, Lang_js_1.__)('SAT Subscriber'))))),
        react_1.default.createElement(Box_1.default, { sx: { display: 'flex', flexDirection: 'column', gap: '14px' } },
            react_1.default.createElement(Box_1.default, null,
                react_1.default.createElement(Box_1.default, { sx: rowCardSx },
                    react_1.default.createElement(Box_1.default, { component: "img", src: "https://cdn.msia.org/shop/wp-content/uploads/sites/9/2008/06/2020-discourses-cropped-600x600.jpeg", alt: "Discourses", sx: {
                            width: '120px',
                            height: '120px',
                            minWidth: '120px',
                            objectFit: 'contain',
                            borderRadius: 2.5,
                        } }),
                    react_1.default.createElement(Box_1.default, { sx: { flex: 1, minWidth: 0 } },
                        react_1.default.createElement(Typography_1.default, { variant: "inherit", component: "h6", sx: { m: 0, fontSize: '18px', fontWeight: 700, color: NAVY } }, (0, Lang_js_1.__)('Discourses')),
                        data.discourses.completed ? (react_1.default.createElement(Typography_1.default, { sx: {
                                mt: '6px',
                                color: '#1a6e1e',
                                fontWeight: 600,
                                fontSize: '14px',
                            } }, (0, Lang_js_1.__)('You have completed all 12 years of Discourses. No further renewal is needed.'))) : data.discourses.subscribed ? (react_1.default.createElement(Box_1.default, { sx: { display: 'flex', gap: 3, flexWrap: 'wrap', mt: '6px', fontSize: '14px', color: 'text.secondary' } },
                            react_1.default.createElement(Typography_1.default, { component: "span", sx: { fontSize: '14px', color: 'text.secondary' } },
                                react_1.default.createElement("strong", null,
                                    (0, Lang_js_1.__)('Year'),
                                    ":"),
                                " ",
                                data.discourses.current_year),
                            react_1.default.createElement(Typography_1.default, { component: "span", sx: { fontSize: '14px', color: 'text.secondary' } },
                                react_1.default.createElement("strong", null,
                                    (0, Lang_js_1.__)('Expires'),
                                    ":"),
                                " ",
                                data.discourses.expires),
                            react_1.default.createElement(Typography_1.default, { component: "span", sx: { fontSize: '14px', color: 'text.secondary' } },
                                react_1.default.createElement("strong", null,
                                    (0, Lang_js_1.__)('Renew After'),
                                    ":"),
                                " ",
                                data.discourses.renew_after))) : (react_1.default.createElement(Typography_1.default, { sx: { mt: '6px', color: 'error.main', fontWeight: 600, fontSize: '14px' } }, data.discourses.lapsed ? (0, Lang_js_1.__)('Expired') : (0, Lang_js_1.__)('Not Yet Subscribed'))),
                        data.discourses.subscribed && !data.discourses.completed && !data.discourses.renewal_eligible && (react_1.default.createElement(Typography_1.default, { sx: {
                                mt: 1,
                                fontSize: '13px',
                                color: 'error.main',
                                fontStyle: 'italic',
                            } }, (0, Lang_js_1.__)('Available for renewal if within 6 months of expiration')))),
                    !data.discourses.completed && (function () {
                        var disabled = data.discourses.subscribed && !data.discourses.renewal_eligible;
                        return (react_1.default.createElement(Link_1.default, { href: disabled ? undefined : '/app/subscriptions/cart?product=discourse', onClick: function (e) { if (disabled)
                                e.preventDefault(); }, sx: actionLinkSx(disabled) }, data.discourses.subscribed ? (0, Lang_js_1.__)('RENEW NOW') : (0, Lang_js_1.__)('SUBSCRIBE NOW')));
                    })()),
                react_1.default.createElement(ProductDetails, { info: data.product_info.discourse })),
            react_1.default.createElement(Box_1.default, null,
                react_1.default.createElement(Box_1.default, { sx: rowCardSx },
                    react_1.default.createElement(Box_1.default, { component: "img", src: "https://cdn.msia.org/shop/wp-content/uploads/sites/9/2008/06/Screenshot_20210415-145121_MSIA-1-1-600x600.jpg", alt: "SATs", sx: {
                            width: '120px',
                            height: '120px',
                            minWidth: '120px',
                            objectFit: 'contain',
                            borderRadius: 2.5,
                        } }),
                    react_1.default.createElement(Box_1.default, { sx: { flex: 1, minWidth: 0 } },
                        react_1.default.createElement(Typography_1.default, { variant: "inherit", component: "h6", sx: { m: 0, fontSize: '18px', fontWeight: 700, color: NAVY } }, (0, Lang_js_1.__)('SATs')),
                        data.sats.subscribed ? (react_1.default.createElement(Box_1.default, { sx: { display: 'flex', gap: 3, flexWrap: 'wrap', mt: '6px' } },
                            react_1.default.createElement(Typography_1.default, { component: "span", sx: { fontSize: '14px', color: 'text.secondary' } },
                                react_1.default.createElement("strong", null,
                                    (0, Lang_js_1.__)('Expires'),
                                    ":"),
                                " ",
                                data.sats.expires),
                            react_1.default.createElement(Typography_1.default, { component: "span", sx: { fontSize: '14px', color: 'text.secondary' } },
                                react_1.default.createElement("strong", null,
                                    (0, Lang_js_1.__)('Renew After'),
                                    ":"),
                                " ",
                                data.sats.renew_after),
                            data.sats.primary && (react_1.default.createElement(Typography_1.default, { component: "span", sx: { color: 'info.main', fontWeight: 600, fontSize: '14px' } },
                                "\u2605 ",
                                (0, Lang_js_1.__)('Primary'))))) : (react_1.default.createElement(Typography_1.default, { sx: { mt: '6px', color: 'error.main', fontWeight: 600, fontSize: '14px' } }, data.sats.lapsed ? (0, Lang_js_1.__)('Expired') : (0, Lang_js_1.__)('Not Yet Subscribed'))),
                        data.discourses.current_year < 1 && (react_1.default.createElement(Typography_1.default, { sx: {
                                mt: 1,
                                fontSize: '13px',
                                color: 'error.main',
                                fontStyle: 'italic',
                            } }, (0, Lang_js_1.__)('SAT subscription becomes available after you start Year 1 of Discourses.')))),
                    (function () {
                        var discourseEligible = data.discourses.current_year >= 1;
                        var disabled = !discourseEligible
                            || (data.sats.subscribed && !data.sats.renewal_eligible);
                        return (react_1.default.createElement(Link_1.default, { href: disabled ? undefined : '/app/subscriptions/cart?product=sat', onClick: function (e) { if (disabled)
                                e.preventDefault(); }, sx: actionLinkSx(disabled) }, data.sats.subscribed ? (0, Lang_js_1.__)('RENEW NOW') : (0, Lang_js_1.__)('SUBSCRIBE NOW')));
                    })()),
                react_1.default.createElement(ProductDetails, { info: data.product_info.sat })),
            react_1.default.createElement(Box_1.default, { sx: rowCardSx },
                react_1.default.createElement(Box_1.default, { component: "img", src: "/images/twi_logo.png", alt: "That Which Is", sx: {
                        width: '120px',
                        height: '120px',
                        minWidth: '120px',
                        objectFit: 'contain',
                        borderRadius: 2.5,
                    } }),
                react_1.default.createElement(Box_1.default, { sx: { flex: 1, minWidth: 0 } },
                    react_1.default.createElement(Typography_1.default, { variant: "inherit", component: "h6", sx: { m: 0, fontSize: '18px', fontWeight: 700, color: NAVY } }, (0, Lang_js_1.__)('That Which Is')),
                    data.twi.subscribed ? (react_1.default.createElement(Box_1.default, { sx: { display: 'flex', gap: 3, flexWrap: 'wrap', mt: '6px' } },
                        react_1.default.createElement(Typography_1.default, { component: "span", sx: { fontSize: '14px', color: 'text.secondary' } },
                            react_1.default.createElement("strong", null,
                                (0, Lang_js_1.__)('Plan'),
                                ":"),
                            " ",
                            data.twi.plan),
                        react_1.default.createElement(Typography_1.default, { component: "span", sx: { fontSize: '14px', color: 'text.secondary' } },
                            react_1.default.createElement("strong", null,
                                (0, Lang_js_1.__)('Next Billing'),
                                ":"),
                            " ",
                            data.twi.next_payment))) : data.twi.lapsed ? (react_1.default.createElement(Box_1.default, { sx: { display: 'flex', gap: 3, flexWrap: 'wrap', mt: '6px' } },
                        react_1.default.createElement(Typography_1.default, { component: "span", sx: { fontSize: '14px', color: 'error.main', fontWeight: 600 } }, (0, Lang_js_1.__)('Expired')),
                        data.twi.expired_on && (react_1.default.createElement(Typography_1.default, { component: "span", sx: { fontSize: '14px', color: 'text.secondary' } },
                            react_1.default.createElement("strong", null,
                                (0, Lang_js_1.__)('Expired On'),
                                ":"),
                            " ",
                            data.twi.expired_on)))) : (react_1.default.createElement(Typography_1.default, { sx: { mt: '6px', color: 'error.main', fontWeight: 600, fontSize: '14px' } }, (0, Lang_js_1.__)('Not Yet Subscribed')))),
                react_1.default.createElement(Box_1.default, { sx: { display: 'flex', flexDirection: 'column', gap: '8px', alignItems: 'stretch' } },
                    react_1.default.createElement(Link_1.default, { href: data.twi.subscribed
                            ? '/app/twi/subscriptions'
                            : '/app/twi/subscribe', sx: actionLinkSx(false) }, data.twi.subscribed ? (0, Lang_js_1.__)('MANAGE') : (0, Lang_js_1.__)('SUBSCRIBE NOW')),
                    react_1.default.createElement(Link_1.default, { href: "/app/subscriptions/cart?product=twi-gift", sx: actionLinkSx(false) }, (0, Lang_js_1.__)('GIFT / EXTEND')))))));
};
var portalContainer = document.getElementById('student-subscriptions-portal');
if (portalContainer) {
    (0, mountIsland_1.mountIsland)(portalContainer, react_1.default.createElement(SubscriptionPortal, null));
}
exports.default = SubscriptionPortal;
